import React from 'react'

type InputProps = React.InputHTMLAttributes<HTMLInputElement>

export default function Input(props: InputProps) {
  return (
    <input
      {...props}
      className="border-b my-1 border-b-gray-400 focus:border-b-gray-100 outline-none text-white bg-transparent p-2 w-full"
    />
  )
}
